module.exports = __webpack_public_path__ + "img/fullscreen-default.e66e3764.svg";